import Multiselect from 'vue-multiselect';
import { Doughnut } from 'vue-chartjs/legacy';
import { Bar } from 'vue-chartjs/legacy';


import indicatorEscl from '../locales/es-CL/indicator.json';
import indicatorEsmx from '../locales/es-MX/indicator.json';
import indicatorEsco from '../locales/es-CO/indicator.json';
import indicatorEnus from '../locales/en-US/indicator.json';

export default {
  name: 'BusinessIntelligence',
  components: {
    Multiselect,
    Doughnut,
    Bar,
  },
  i18n: {
    messages: {
      'es-CL': {
        indicator: indicatorEscl,
      },
      'es-MX': {
        indicator: indicatorEsmx,
      },
      'es-CO': {
        indicator: indicatorEsco,
      },
      'en-US': {
        indicator: indicatorEnus,
      },
    },
  },
  data() {
    return {
      canUseIndicatorV2: false,
      dataAccess: null,
    };
  },
  async created() {
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      if (this.$store.getters.clientId == 301 && this.dataAccess.canNavIndicatorV2) {
        this.canUseIndicatorV2 = true;
      }
    },
  },
  computed: {},
};
